import { useParams } from "react-router-dom";
import "./CustomerqaDetail.scss";
import "../Service/Institution.scss";
import { useState } from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { MdClose } from "react-icons/md";

function ApplyForm({ applyFormVisible, setApplyFormVisible }) {
  useEffect(() => {
    getUserData();
  }, []);

  const decodedToken = jwtDecode(window.sessionStorage.getItem("token"));

  // 실무자 정보 입력
  const [staffName, setStaffName] = useState("");
  const [staffPosition, setStaffPosition] = useState("");
  const [staffEmail, setStaffEmail] = useState("");
  const [staffNum, setStaffNum] = useState("");

  const [applyType, setApplyType] = useState("");
  const [applyRange, setApplyRange] = useState("");
  const [applyContent, setApplyContent] = useState("");
  const [applyField, setApplyField] = useState("");
  const [receptionField, setReceptionField] = useState("");

  const [memberData, setMemberData] = useState([]);
  const [staffList, setStaffList] = useState([]);

  const [flagFile, setFlagFile] = useState(false);

  // files 데이터
  const [files, setFiles] = useState([]);

  // 회원정보입력 Handler
  const onChangeHandler = (event) => {
    const eventId = event.target.id;
    if (eventId === "staffName") {
      setStaffName(event.target.value);
    }
    if (eventId === "staffPosition") {
      setStaffPosition(event.target.value);
    }
    if (eventId === "staffEmail") {
      setStaffEmail(event.target.value);
    }
    if (eventId === "staffNum") {
      setStaffNum(event.target.value);
    }
    if (eventId === "applyType") {
      setApplyType(event.target.value);
    }
    if (eventId === "applyRange") {
      setApplyRange(event.target.value);
    }
    if (eventId === "applyContent") {
      setApplyContent(event.target.value);
    }
    if (eventId === "applyField") {
      setApplyField(event.target.value);
    }
    if (eventId === "receptionField") {
      setReceptionField(event.target.value);
    }
  };

  // 회원정보 데이터 받기
  const getUserData = async () => {
    try {
      const response = await axios.get(`/api/applicant/${decodedToken.sub}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setMemberData(response.data);
      if (response.data.staffName2 === "") {
        setStaffList([response.data.staffName1]);
      } else {
        setStaffList([response.data.staffName1, response.data.staffName2]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // 실무자 정보 입력 SelectBox
  const staffSelectHandler = (event) => {
    if (event.target.value === "0") {
      setStaffName(memberData.staffName1);
      setStaffPosition(memberData.staffPosition1);
      setStaffEmail(memberData.staffEmail1);
      setStaffNum(memberData.staffTelNum1);
    }
    if (event.target.value === "1") {
      setStaffName(memberData.staffName2);
      setStaffPosition(memberData.staffPosition2);
      setStaffEmail(memberData.staffEmail2);
      setStaffNum(memberData.staffTelNum2);
    }
    if (event.target.value === "직접입력") {
      setStaffName("");
      setStaffPosition("");
      setStaffEmail("");
      setStaffNum("");
    }
  };
  // 파일추가, 삭제
  const addFiles = (event) => {
    setFiles((state) => {
      return [...state, event.target.files[0]];
    });
  };
  const deleteFileHandler = (e) => () => {
    setFiles((state) => {
      const filteredFiles = state.filter((el) => el.name !== e.name);
      return [...filteredFiles];
    });
  };
  const submitForm = () => {
    Swal.fire({
      icon: "success",
      title: "완료",
      text: "이의불만분쟁 신청완료",
      confirmButtonColor: "dodgerBlue",
      iconColor: "dodgerBlue",
    });
    setApplyFormVisible(!applyFormVisible);
    console.log(
      staffName,
      staffPosition,
      staffEmail,
      staffNum,
      applyType,
      applyRange,
      applyContent,
      applyField,
      receptionField
    );
  };

  return (
    <div className="customcenter_area" style={{ backgroundColor: "#eaedf1" }}>
      <section className="customcenter_title_row">
        <div className="customcenter_title_col">
          <p>이의불만분쟁 신청</p>
        </div>
        <p className="customcenter_title_col">
          신청정보와 이의불만분쟁 상세정보를 입력해주세요.
        </p>
      </section>
      <div
        className="step1_institution"
        style={{
          backgroundColor: "white",
          borderRadius: "5px",
          marginTop: "30px",
        }}
      >
        <div className="contain my_institution_wrap" style={{ padding: "0px" }}>
          <form className="my_institution" action="" method="">
            <div className="working_person_info">
              <h1>
                <span>인증 신청 실무자 정보 입력</span>
              </h1>
              <div className="select_box">
                <select onChange={staffSelectHandler}>
                  <option value="직접입력">직접입력</option>
                  {staffList.map((e, idx) => (
                    <option value={idx}>{e}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col" style={{ marginBottom: "0px" }}>
                <div className="input_row">
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffName"
                        className="input_line"
                        type="text"
                        placeholder="실무자이름"
                        onChange={onChangeHandler}
                        value={staffName}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffPosition"
                        className="input_line"
                        type="text"
                        placeholder="직책"
                        onChange={onChangeHandler}
                        value={staffPosition}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffEmail"
                        className="input_line"
                        type="email"
                        placeholder="이메일"
                        onChange={onChangeHandler}
                        value={staffEmail}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="staffNum"
                        className="input_line"
                        type="text"
                        placeholder="실무자 연락처"
                        onChange={onChangeHandler}
                        value={staffNum}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col" style={{ padding: "0 32px" }}>
                <section className="select_box_area" style={{ width: "100%" }}>
                  <div
                    className="select_box_contain"
                    style={{ width: "760px" }}
                  >
                    <div className="select_box" style={{ width: "375px" }}>
                      <select
                        id="applyField"
                        style={{ backgroundColor: "#f8f8f8" }}
                        onChange={onChangeHandler}
                        value={applyField}
                      >
                        <option value="item" selected>
                          접수분야선택
                        </option>
                        <option value="0">이의제기</option>
                        <option value="1">불만</option>
                        <option value="2">분쟁</option>
                      </select>
                    </div>
                    <div className="select_box" style={{ width: "375px" }}>
                      <select
                        id="receptionField"
                        style={{ backgroundColor: "#f8f8f8" }}
                        onChange={onChangeHandler}
                        value={receptionField}
                      >
                        <option value="item" selected>
                          신청분야선택
                        </option>
                        <option value="0">인증</option>
                        <option value="1">인정</option>
                        <option value="2">시험</option>
                        <option value="3">민간지원</option>
                      </select>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div className="row">
              <div className="col" style={{ padding: "0 32px" }}>
                <div className="input_row">
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="applyType"
                        className="input_line"
                        style={{ width: "375px" }}
                        type="text"
                        placeholder="분야: ex)단말기(OBU)/노변기지국(RSU)"
                        onChange={onChangeHandler}
                        value={applyType}
                      />
                    </div>
                  </div>
                  <div className="input_col">
                    <div className="input_wrap">
                      <input
                        id="applyRange"
                        className="input_line"
                        style={{ width: "375px" }}
                        type="text"
                        placeholder="범위: ex)통신/서비스/성능/보안"
                        onChange={onChangeHandler}
                        value={applyRange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col" style={{ padding: "0 32px" }}>
                <div className="input_row">
                  <textarea
                    id="applyContent"
                    placeholder="이의제기/불만/분쟁 신청내용을 구체적으로 입력해주세요."
                    style={{
                      backgroundColor: "#eee",
                      width: "770px",
                      height: "100px",
                    }}
                    onChange={onChangeHandler}
                    value={applyContent}
                  ></textarea>
                </div>
              </div>
              {files.length > 0 && (
                <>
                  <h1>첨부파일</h1>
                  <section className="new">
                    {files.map((e) => {
                      return (
                        <div className="addfile_upload">
                          <div
                            className="addfile_upload_status file_name"
                            style={{ width: "500px", marginLeft: "150px" }}
                          >
                            <p className="">{e.name}</p>
                            <button
                              type="button"
                              onClick={deleteFileHandler(e)}
                            >
                              <MdClose />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </section>
                </>
              )}
              <div className="input_wrap submit_btn">
                <input
                  className="input_box file_input"
                  type="file"
                  id="file"
                  style={{
                    visibility: "hidden",
                    width: "30px",
                  }}
                  onChange={addFiles}
                />
                <label
                  htmlFor="file"
                  className="btn_line"
                  style={{ height: "37px" }}
                >
                  파일첨부
                </label>
                <button
                  type="button"
                  className="btn_line"
                  onClick={() => {
                    setApplyFormVisible(!applyFormVisible);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  className="btn_color"
                  onClick={submitForm}
                >
                  신청
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="input_wrap submit_btn"></div>
    </div>
  );
}
export default ApplyForm;
